// extracted by mini-css-extract-plugin
export default {"top":"depositSettings_top__Ffqeu"};